/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Page_SubtitleInputs */

const en_invite_page_subtitle = /** @type {(inputs: Invite_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earn rewards as the people you invite spend time focusing.`)
};

const ar_invite_page_subtitle = /** @type {(inputs: Invite_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اكسب مكافآت عندما يقضي الأشخاص الذين تدعوهم وقتًا في التركيز.`)
};

const de_invite_page_subtitle = /** @type {(inputs: Invite_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verdiene Belohnungen, wenn die von dir eingeladenen Personen fokussieren.`)
};

const es_invite_page_subtitle = /** @type {(inputs: Invite_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gana recompensas cuando las personas que invitas pasan tiempo concentrándose.`)
};

const fr_invite_page_subtitle = /** @type {(inputs: Invite_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagnez des récompenses quand les personnes que vous invitez passent du temps à se concentrer.`)
};

const it_invite_page_subtitle = /** @type {(inputs: Invite_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottieni ricompense quando le persone che inviti passano tempo a concentrarsi.`)
};

const ja_invite_page_subtitle = /** @type {(inputs: Invite_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待した人が集中するほど、報酬を獲得できます。`)
};

const ko_invite_page_subtitle = /** @type {(inputs: Invite_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초대한 사람들이 집중한 시간에 따라 보상을 받아요.`)
};

const pt_br_invite_page_subtitle = /** @type {(inputs: Invite_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganhe recompensas quando as pessoas que você convidar passarem tempo focando.`)
};

const ru_invite_page_subtitle = /** @type {(inputs: Invite_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получайте награды, когда приглашенные вами люди проводят время, фокусируясь.`)
};

const th_invite_page_subtitle = /** @type {(inputs: Invite_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รับรางวัลเมื่อคนที่คุณเชิญใช้เวลาโฟกัส`)
};

const tr_invite_page_subtitle = /** @type {(inputs: Invite_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davet ettiğin kişiler odaklanmaya zaman ayırdıkça ödüller kazan.`)
};

const zh_cn_invite_page_subtitle = /** @type {(inputs: Invite_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你邀请的人专注越久，你的奖励越多。`)
};

const zh_tw_invite_page_subtitle = /** @type {(inputs: Invite_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你邀請的人專注越久，你的獎勵越多。`)
};

/**
* | output |
* | --- |
* | "Earn rewards as the people you invite spend time focusing." |
*
* @param {Invite_Page_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invite_page_subtitle = /** @type {((inputs?: Invite_Page_SubtitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Page_SubtitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_page_subtitle(inputs)
	if (locale === "ar") return ar_invite_page_subtitle(inputs)
	if (locale === "de") return de_invite_page_subtitle(inputs)
	if (locale === "es") return es_invite_page_subtitle(inputs)
	if (locale === "fr") return fr_invite_page_subtitle(inputs)
	if (locale === "it") return it_invite_page_subtitle(inputs)
	if (locale === "ja") return ja_invite_page_subtitle(inputs)
	if (locale === "ko") return ko_invite_page_subtitle(inputs)
	if (locale === "pt_br") return pt_br_invite_page_subtitle(inputs)
	if (locale === "ru") return ru_invite_page_subtitle(inputs)
	if (locale === "th") return th_invite_page_subtitle(inputs)
	if (locale === "tr") return tr_invite_page_subtitle(inputs)
	if (locale === "zh_cn") return zh_cn_invite_page_subtitle(inputs)
	return zh_tw_invite_page_subtitle(inputs)
});